export default __webpack_public_path__ + "static/media/Page4_BG.426d1276.png";